import { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import { Mail, RefreshCw, ArrowLeft } from "lucide-react";

const VerifyEmail = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");

  const handleResend = async () => {
    if (!email) {
      toast.error(t("auth.errors.emailRequired"));
      return;
    }

    setLoading(true);
    const { error } = await supabase.auth.resend({
      type: "signup",
      email,
      options: {
        emailRedirectTo: `${window.location.origin}/dashboard`,
      },
    });
    setLoading(false);

    if (error) {
      toast.error(error.message);
    } else {
      toast.success(t("auth.verificationResent"));
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="bg-[hsl(var(--accent-purple))] rounded-2xl border-2 border-foreground p-8 text-center">
          <Link to="/" className="logo block text-center mb-6">
            Vesper
          </Link>

          <Mail className="w-16 h-16 mx-auto mb-4" />
          <h1 className="heading-card mb-4">{t("auth.verifyEmail")}</h1>
          <p className="text-foreground/80 mb-6">{t("auth.verifyEmailDesc")}</p>

          <div className="space-y-4">
            <div>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-3 rounded-full border-2 border-foreground bg-background text-foreground placeholder:text-foreground/50 focus:outline-none focus:ring-2 focus:ring-primary"
                placeholder={t("auth.emailPlaceholder")}
              />
            </div>

            <button
              onClick={handleResend}
              disabled={loading}
              className="w-full btn-primary justify-center disabled:opacity-50"
            >
              <RefreshCw className={`w-4 h-4 ${loading ? "animate-spin" : ""}`} />
              {loading ? t("auth.loading") : t("auth.resendVerification")}
            </button>
          </div>

          <p className="text-center mt-6 text-sm">
            <Link to="/login" className="font-semibold hover:underline inline-flex items-center gap-2">
              <ArrowLeft className="w-4 h-4" />
              {t("auth.backToLogin")}
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;
